module.exports = __webpack_public_path__ + "resources/img/img_main_bnr_nhncloud_book_m.ad79ed03e207dd609a25e61e5a6d2ab2.png";